<template>
  <div id="purchaseOrderInfo">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2">
        <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
      </el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
    </el-row>
    <el-col class="fl searthPart" style="width: 19%;">
      <p class="headerT">采购订单信息</p>
      <el-form ref="purchaseForm" :model="purchaseForm" label-width="90px" :label-position="labelPosition">
        <el-form-item label="订单编号:">
          <el-input :disabled="true" v-model="purchaseForm.code">
          </el-input>
          <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(purchaseForm.code,$event)"></i>
        </el-form-item>
        <el-form-item label="供应商:">
          <el-input :disabled="true" v-model="purchaseForm.supplierName" ></el-input>
        </el-form-item>
        <el-form-item label="账期:">
          <el-input :disabled="true" v-model="purchaseForm.paymentTime" ></el-input>
         </el-form-item>
        <el-form-item label="采购日期:">
          <el-input :disabled="true" v-model="purchaseForm.purchaseTime" ></el-input>
        </el-form-item>
        <el-form-item label="交货日期:">
          <el-input :disabled="true" v-model="purchaseForm.aogTime" ></el-input>
         </el-form-item>
        <el-form-item label="到货百分比:">
          <el-input :disabled="true" v-model="purchaseForm.aogPercentage" ></el-input>
        </el-form-item>
        <el-form-item label="退货总量:">
          <el-input :disabled="true" v-model="purchaseForm.salesReturnSum" ></el-input>
        </el-form-item>
        <el-form-item label="退货率:">
          <el-input :disabled="true" v-model="purchaseForm.salesReturnPercentage" ></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-input :disabled="true" v-if="purchaseForm.status == 'YQR'" value="已确认"></el-input>
          <el-input :disabled="true" v-else-if="purchaseForm.status == 'CG'" value="暂存"></el-input>
          <el-input :disabled="true" v-else value="已完成"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col class="fr" style="width: 79%;">
      <el-button-group style="margin-bottom: 20px;">
        <el-button :class="{activeBtn:activeBtnIndex === index}" v-for="(item,index) in orderStates" @click="changeState(item,index)" :key="index">{{item.name}}</el-button>
      </el-button-group>
      <!-- <p class="headerT">供应商信息详情</p> -->
      <el-card class="box-card fr" style="width: 100%;" v-if="activeBtnIndex ==0">
        <el-table
          :data="returnData"
          border
          :header-cell-style="{'text-align':'center'}"
          :summary-method="getSummaries"
          show-summary
          style="width: 100%">
          <el-table-column
            align="center"
            type="index"
            width="50"
            label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialCode"
            label="物料编号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="materialName"
            label="物料名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="number"
            label="采购数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="price"
            :formatter="addCommas"
            label="采购单价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="amout"
            :formatter="addCommas"
            label="合计金额">
            
          </el-table-column>
          <el-table-column
            align="center"
            prop="aogSum"
            label="到货数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="aogPercentage"
            label="到货百分比">
          </el-table-column>
          <el-table-column
            align="center"
            prop="salesReturnSum"
            label="退货数量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="salesReturnPercentage"
            label="退货率">
          </el-table-column>
          
        </el-table>
        <el-button v-if="basicsAuth.purchaseOrdersClose" type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">手动关闭订单</el-button>
      </el-card>
      <el-row  v-if="activeBtnIndex ==1">
        <ul>
          <li v-for="(item,index) in procurementEvents" :key="index" class="eventLi">
            <span class="createTime childSpan clearfix" v-if="item.createTime">
              <i class="fl"></i>
              <span class="fl">{{formatTime(item.createTime)}}</span><br>
            </span>
            <span class="details childSpan" v-if="item.details">{{item.details}}<br></span>
            <span class="attribute1 childSpan" v-if="item.attribute1">
              {{item.attribute1.substring(0,item.attribute1.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute1.substring(item.attribute1.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
            <span class="attribute2 childSpan" v-if="item.attribute2">
              <!-- {{item.attribute2}}<br> -->
              {{item.attribute2.substring(0,item.attribute2.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute2.substring(item.attribute2.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
            <span class="attribute3 childSpan" v-if="item.attribute3">
              <!-- {{item.attribute3}}<br> -->
              {{item.attribute3.substring(0,item.attribute3.lastIndexOf('：')+1)}}
              <span class="orderId">
              {{item.attribute3.substring(item.attribute3.lastIndexOf('：')+1,)}}
              </span><br>
            </span>
          </li>
        </ul>
        <!-- <h2>{{valueTime}}</h2> -->
      </el-row>
    </el-col>
  </div>
</template>

<script>
  let moment = require("moment");
  import clip from '@/util/clipboard'
  import {
      getPurchaseOrdersInfo,purchaseOrdersClose
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest';
  export default {
    name: 'purchaseOrderInfo',
    components: {
    },
    data () {
      return {
        valueTime:'',
        orderId:'',
        activeBtnIndex:0,
        orderStates:[{name:'订单详情'},{name:'订单事件'},],
        labelPosition:'left',
        purchaseForm:{
          code: '',
          supplierName: '',
          paymentTime: '',
          purchaseTime: '',
          aogTime: '',
          aogPercentage: '',
          salesReturnSum: '',
          salesReturnPercentage: '',
          status: ''
        },
        returnData: [
          { 
            materialCoding:'',
            materialName:'', 
            number:'', 
            price:'', 
            amout:'', 
            aogSum:'', 
            aogPercentage:'', 
            salesReturnSum:'', 
            salesReturnPercentage:'',
          },
        ],
        basicsAuth:{
          purchaseOrdersClose:false
        }
      }
    },
    mounted () {
      
      if (!this.$route.query.orderId) {
        var userOrderId = sessionStorage.getItem('saveOrderId');
        this.orderId = JSON.parse(userOrderId);
      }else{
        let orderId = this.$route.query.orderId
        this.orderId = orderId
      }
      this.getPurchaseOrdersInfo()
      if (this.returnData.amout > 0) {
        this.returnData.amout = this.toThousands2(this.returnData.amout)
      }
       

    },
    created:function(){
      this.$destroy(); //销毁生命周期
      this.basicsAuth.purchaseOrdersClose = getPermission('/api/purchase/purchaseOrdersClose');
      this.basicsAuth.purchaseOrdersClose = getPermission('/api/purchase/purchaseOrdersClose');
    },
    methods: {
      //时间转化函数
      formatTime (ndate) {
        if (!ndate) {
          return '-'
        }
        const date = new Date(ndate)
        var year = date.getFullYear()
        var month = date.getMonth() + 1
        var day = date.getDate()
        var hour = date.getHours()
        var minute = date.getMinutes()
        var second = date.getSeconds()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (day >= 0 && day <= 9) {
          day = '0' + day
        }
        if (hour >= 0 && hour <= 9) {
          hour = '0' + hour
        }
        if (minute >= 0 && minute <= 9) {
          minute = '0' + minute
        }
        if (second >= 0 && second <= 9) {
          second = '0' + second
        }
        var result = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
        return result
      },
      //金额转化函数
      addCommas:function(row,column){
        var num = row[column.property];
        var b= num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      toThousands2(num) {
        // this.materForm.backUpPrice = num
        // var num = row[column.property];
        num = num.toString().replace(/\$|\,/g,'');
        if(isNaN(num))
            num = "0";
        var sign = (num == (num = Math.abs(num)));
        num = Math.floor(num*100+0.50000000001);
        var cents = num%100;
        num = Math.floor(num/100).toString();
        if(cents<10)
        cents = "0" + cents;
        for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
        num = num.substring(0,num.length-(4*i+3))+','+
        num.substring(num.length-(4*i+3));
        return (((sign)?'':'-') + num + '.' + cents);
      },
      //获取订单详情
      getPurchaseOrdersInfo() {
        let para={
          id: this.orderId,
        }
        getPurchaseOrdersInfo(para).then(res => {          
          if (res.data.status==100) {            
            // console.log(res.data.results)  
            this.returnData = res.data.results.purchaseDetails.list
            this.returnData.forEach((item) =>{
              return item.amout = item.price*item.number
            })
            // this.returnData.amout = this.returnData.number * this.returnData.price 
            this.purchaseForm = res.data.results.purchaseOrdersInfo
            this.purchaseForm.purchaseTime = moment(res.data.results.purchaseOrdersInfo.purchaseTime).format("YYYY-MM-DD");
            this.purchaseForm.aogTime = moment(res.data.results.purchaseOrdersInfo.aogTime).format("YYYY-MM-DD");
            sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.purchaseOrdersInfo.id));
            this.procurementEvents = res.data.results.procurementEvents
            
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //取消订单
      cancelOrder(){//delPurchasingInfo
        console.log('dd')
        let para={
          id:this.purchaseForm.id,
        }
        // console.log(para)
        purchaseOrdersClose(para).then(res => {
          if (res.data.status==100) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.tabRemove(this.$route.path)
            this.$router.replace({
              path:'/purchaseOrderManage'
            })
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
        
      },
      tabRemove (targetName) {
          // 首页不可删除
          if(targetName == '/') {
            return;
          }
          //将该tab从options里移除
          this.$store.commit('delete_tabs', targetName);
          ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
          if (this.activeIndex === targetName) {
            // 设置当前激活的路由
            if (this.options && this.options.length >= 1) {
              this.$store.commit('set_active_index', this.options[this.options.length-1].route);
              this.$router.push({path: this.activeIndex});
            } else {
              this.$router.push({path: '/welcome'});
            }
          }
        },
      //复制内容
      handleCopy(text, event) {
         clip(text, event)
         console.log(text)
      },
      //返回上一页
      backGo() {
        this.$router.push({
          path:'/purchaseOrderManage'
        })
        // this.$router.push({
        //   path:'/newPurchaseOrder',
        //     query:{
        //       orderId:this.orderId
        //     }
        //   })
      },
      refresh() {
        this.getPurchaseOrdersInfo()
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 4) {
            return;
          }
          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += '';
          } else {
            sums[index] = '';
          }
        });
        if (sums[5] > 0) {
          sums[5] = this.toThousands2(sums[5]);
        }
        return sums;
      },
     //切换订单详情与订单事件
      changeState(item,index) {
        this.activeBtnIndex = index
       }
    },
    computed: {
    },
    watch: {
      
    },
    
  }
</script>

<style type="text/css" lang="scss" scoped>
  #purchaseOrderInfo{
    font-size: 14px;
    .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
    .el-input{width: 85%;}
    .headerT{font-size: 16px;margin:0 0 15px 0;}
    .activeBtn{background-color: #1abc9c;color:#fff;}
    .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
      .childSpan{padding-left: 20px;margin-bottom: 5px;}
      .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
      .childSpan span.orderId{color: #3399FF;}
      .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
        background-color: #1abc9c;margin: 0px 15px 0px -5px;}
    }
    .el-step__line{background-color: #1abc9c;}
    .el-step__icon-inner{color:#1abc9c;}
    /*.el-step__icon{width: 10px;height: 10px;}*/
    .el-step__icon.is-text{border-color: #1abc9c;}
  }
  
</style>



// WEBPACK FOOTER //
// purchaseOrderInfo.vue?02c0f939